import _aspectRatio from "./variants/aspectRatio.mjs"
const config = { "aspectRatio": _aspectRatio }
export { config as default, _aspectRatio }